import { PlusIcon, Trash01Icon } from '@langchain/untitled-ui-icons';

import * as React from 'react';

import { MultiSelect } from '@/components/MultiSelect';
import { Tooltip } from '@/design-system';

export const MultiNumberArray = (props: {
  value: unknown;
  onChange: (value: number[]) => void;
  enum: number[];
  disableAutoFocus?: boolean;
}) => {
  const safeValue =
    Array.isArray(props.value) &&
    props.value.every((x) => typeof x === 'number')
      ? props.value
      : [];

  if (props.enum.length === 0) {
    return (
      <div className="grid grid-cols-[1fr,auto] items-start gap-1.5">
        {safeValue.map((value, idx) => (
          <React.Fragment key={idx}>
            <input
              autoFocus={!props.disableAutoFocus}
              className="w-full rounded-lg border border-secondary bg-background p-3 transition-colors focus-within:border-brand"
              placeholder="Input"
              type="number"
              value={
                typeof value !== 'number' || Number.isNaN(value) ? 0 : value
              }
              onChange={(e) => {
                const newValue = [...safeValue];
                newValue[idx] = e.target.valueAsNumber;
                props.onChange(newValue);
              }}
            />

            <Tooltip title="Remove">
              <button
                type="button"
                className="flex h-[38px] w-[38px] flex-shrink-0 items-center justify-center rounded-lg border border-secondary p-1 outline-none transition-colors focus-within:border-brand hover:bg-secondary-hover"
                onClick={() => {
                  const newValue = [...safeValue];
                  newValue.splice(idx, 1);
                  props.onChange(newValue);
                }}
              >
                <Trash01Icon className="size-4" />
              </button>
            </Tooltip>
          </React.Fragment>
        ))}

        <div>
          <button
            type="button"
            className="flex items-center gap-1.5 rounded-lg border border-secondary px-2 py-1 text-sm outline-none transition-colors focus-within:border-brand hover:bg-secondary-hover"
            onClick={() => {
              props.onChange([...safeValue, 0]);
            }}
          >
            <PlusIcon className="size-4" />
            <span>Add</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <MultiSelect
      value={safeValue.map((x) => x.toString())}
      onChange={(value) => {
        props.onChange(value.map((x) => parseFloat(x)));
      }}
      autocompleteList={props.enum.map((option) => ({
        id: option.toString(),
        display: option.toString(),
      }))}
      emptyState="No options available"
    />
  );
};
